import script from "./CreatedList.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedList.vue?vue&type=script&setup=true&lang=js"

import "./CreatedList.vue?vue&type=style&index=0&id=18a35dc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a35dc3"]])

export default __exports__